import { Link } from "react-router-dom"
import { ChevronRight } from 'lucide-react'
import "./Market.css"

const Market = () => {
  const marketSegments = [
    {
      name: "Assembly & Solution For Vehicles",
      categoryId: "DA3446", // Change this to your actual category ID
    },
    {
      name: "Assemblies & Hoses for Medical Line",
      categoryId: "C8045E", // Change this to your actual category ID
    },
    {
      name: "Assembly & Solution For Construction Industry",
      categoryId: "6ED72F", // Change this to your actual category ID
    },
    {
      name: "Assembly & Solution For Hardware Industry",
      categoryId: "AAAB3E", // Change this to your actual category ID
    },
    {
      name: "Assembly & Solution For Two Wheeler Segment",
      categoryId: "AC711F", // Change this to your actual category ID
    },
    {
      name: "Assembly & Solution For Railway",
      categoryId: "0DFCFF", // Change this to your actual category ID
    },
    {
      name: "Assembly & Solution For Military",
      categoryId: "AC1C9F", // Change this to your actual category ID
    },
    {
      name: "Hoses & Tubes for General Purpose",
      categoryId: "1AEBF2", // Change this to your actual category ID
    },
    {
      name: "Assemblies for EV Vehicle",
      categoryId: "673A6D", // Change this to your actual category ID
    },
  ]

  return (
    <div className="market-page-wrapper">
      {/* Hero Section */}
      <section className="market-hero-section">
        <div className="market-hero-container">
          <div className="market-hero-content">
            <span className="market-hero-subtitle">OUR MARKET</span>
            <h1 className="market-hero-title">Market Solutions</h1>
            <p className="market-hero-description">Explore our specialized market segments and industry solutions</p>
          </div>
        </div>
      </section>

      {/* Market List Section */}
      <section className="market-list-section">
        <div className="market-container">
          <div className="market-section-header">
            <h2 className="market-section-title">Our Market Segments</h2>
          </div>
          <div className="market-list">
            {marketSegments.map((segment, index) => (
              <Link 
                key={index} 
                to="/market/products" 
                state={{ categoryId: segment.categoryId, categoryName: segment.name }}
                className="market-item"
              >
                <div className="market-item-content">
                  <span className="market-item-name">{segment.name}</span>
                  <ChevronRight className="market-item-arrow" />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}

export default Market
